import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  .swiper-button-next,
  .swiper-button-prev {
    background-color: rgba(255, 255, 255, 0.4);
    border: 1px solid ${({ theme }) => theme.palette.white};
  }
`;

export const AdvertisementWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  width: fit-content !important;
  height: fit-content !important;
  z-index: 9;
  padding: 4px 10px;
  background-color: ${({ theme }) => theme.palette.lightClearBlue};
`;
export const AdvertisementText = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;

export const SecureLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 10px;
  width: fit-content !important;
  height: fit-content !important;
  z-index: 9;
`;

export const SeturLogoWrapper = styled.div`
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 15px;
  right: 10px;
  width: auto !important;
  height: fit-content !important;
  z-index: 100;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    bottom: 15px;
  }
`;

export const SeturVideoWrapper = styled.div`
  position: absolute;
  top: 8.5px;
  right: 8.5px;
  z-index: 100;
`;

export const PrevIcon = styled.button`
  cursor: pointer;
  border: none;
  position: absolute;
  z-index: 2;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  max-width: fit-content;
  background-color: transparent !important;
  padding: 0;
  box-shadow: none !important;
`;
export const NextIcon = styled.button`
  cursor: pointer;
  border: none;
  position: absolute;
  z-index: 2;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  max-width: fit-content;
  background-color: transparent !important;
  padding: 0;
  box-shadow: none !important;
`;

export const IconWrapper = styled.div`
  max-width: fit-content;
  padding: 10px;
  opacity: 0.5;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 100%;
`;
